import Image from 'next/image';
import Check from 'public/check_mark.svg';
import React from 'react';
import { AuthDialog, ButtonDialog, MessageDialog, Overlay, TitleDialog } from './Auth.styled';

type Props = {
  title?: string;
  message: string;
  cta: {
    message: string;
    link: string;
  };
};

export default function Dialogue({ title, message, cta }: Props) {
  return (
    <Overlay>
      <AuthDialog>
        <Image src={Check} width={87} height={87} alt="check mark" />
        <TitleDialog>{title}</TitleDialog>
        <MessageDialog>{message}</MessageDialog>
        <ButtonDialog href={cta.link}>{cta.message}</ButtonDialog>
      </AuthDialog>
    </Overlay>
  );
}
